import BaseModel from "../../core/components/input-widget/BaseModel";

export default class SettlementChargeModel extends BaseModel {
  uuid = null;
  amount = null;
  taxable = null;
  vat = null;
  charge = {};

  attributeLabels = {};

  rules = {};

  attributeHints = {}

  toJSON() {
    let params = super.toJSON();

    return {
      uuid: params.uuid,
      amount: params.amount,
      taxable: params.taxable,
    }
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}